export default {
  LS: 'ls',
  MY: 'my',
};
